module.exports = __webpack_public_path__ + "img/noimg.cff35d19.jpg";